import { useMemo, useState } from "react";
import { Reveal, SectionLabel } from "../components/Reveal";
import { useProjects } from "../hooks/useProjects";

export default function Projects() {
  const { projects } = useProjects();
  const [cat, setCat] = useState("All");
  const cats = useMemo(
    () => ["All", ...Array.from(new Set(projects.map((p) => p.cat).filter(Boolean)))],
    [projects]
  );
  const filtered = cat === "All" ? projects : projects.filter((p) => p.cat === cat);

  return (
    <div className="pt-32">
      <section className="max-w-7xl mx-auto px-6">
        <Reveal><SectionLabel>Our Projects</SectionLabel></Reveal>
        <Reveal delay={0.1}>
          <h1 className="font-serif-display text-5xl md:text-6xl mt-6 max-w-3xl leading-tight">
            A portfolio of fulfilled wishes.
          </h1>
        </Reveal>

        <div className="mt-12 flex flex-wrap gap-3">
          {cats.map((c) => (
            <button
              key={c}
              data-testid={`filter-${c.toLowerCase().replace(/\s/g, "-")}`}
              onClick={() => setCat(c)}
              className={`rounded-full px-5 py-2 text-sm font-medium border transition-colors duration-300 ${
                cat === c ? "bg-primary text-primary-foreground border-primary" : "border-border hover:border-accent hover:text-accent"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid lg:grid-cols-12 gap-6">
          {filtered.map((p, i) => (
            <Reveal key={p.id || p.title} delay={i * 0.06} className={p.span}>
              <div data-testid={`project-${i}`} className="group relative rounded-2xl overflow-hidden aspect-[4/3]">
                <img src={p.img} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent opacity-90" />
                <div className="absolute bottom-0 p-7 text-white">
                  <p className="label-caps text-accent">{p.area ? `${p.cat} · ${p.area}` : p.cat}</p>
                  <h3 className="font-serif-display text-3xl mt-1">{p.title}</h3>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
